import DOMPurify from 'dompurify';

interface HTMLRendererProps {
  htmlString: string;
}

const HTMLRenderer = ( { htmlString }: HTMLRendererProps) => {
  const cleanHtmlString = DOMPurify.sanitize(htmlString);

  return (
    <div dangerouslySetInnerHTML={{ __html: cleanHtmlString }}></div>
  )
}

export default HTMLRenderer;
